export class WaitDialog {
  open<T>(message: string, factory: () => Promise<T>): Promise<T> {
    return Promise.resolve(<T>null);
  }
}
